<div class="alert alert-danger">
    <h3 class="alert-heading disconnect-msg">{{{o.messages[0]}}}</h3>
    {[ o.messages.slice(1).forEach(function (msg) { ]}
        <p class="disconnect-msg">{{{msg}}}</p>
    {[ }); ]}
</div>
